// Named as shops name the work most often in their own records.
const kLabels: Record<string, string> = {
  engine_oil: '机油及机滤',
  air_filter: '空气滤芯',
  cabin_filter: '空调滤芯',
  fuel_filter: '燃油滤芯',
  brake_fluid: '刹车油',
  coolant: '防冻液',
  spark_plugs: '火花塞',
  transmission_fluid: '变速箱油',
  driveline_oil: '差速器油',
  // A due the shop's records name only as routine service.
  general_maintenance: '常规保养',
};

export function routineCategoryLabel(category: string): string {
  return kLabels[category] ?? category;
}
